import { render, staticRenderFns } from "./TestArArr.vue?vue&type=template&id=371e2bae&scoped=true&"
import script from "./TestArArr.vue?vue&type=script&lang=js&"
export * from "./TestArArr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "371e2bae",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wangmin/Projects/devidia_projects/devidia-p1-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('371e2bae')) {
      api.createRecord('371e2bae', component.options)
    } else {
      api.reload('371e2bae', component.options)
    }
    module.hot.accept("./TestArArr.vue?vue&type=template&id=371e2bae&scoped=true&", function () {
      api.rerender('371e2bae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/test/mindAr/components/TestArArr.vue"
export default component.exports